<template>
  <div>
    <el-tabs v-model="approveTypeActiveName" @tab-click="handleApproveTypeClickTab">
      <el-tab-pane name="DATA_RELEASE" label="原始数据">
        <template slot="label">
          <span class="position-relative">
           原始数据<i v-if="tabRedDotNum('total','DATA_RELEASE')" class="red-dot2">{{ tabRedDotNum('total','DATA_RELEASE') }}</i>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane name="REPORT_UPLOAD" label="报告" >
        <template slot="label">
          <span class="position-relative">
           报告<i v-if="tabRedDotNum('total','REPORT_UPLOAD')" class="red-dot2">{{ tabRedDotNum('total','REPORT_UPLOAD') }}</i>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
    <el-card  style="margin-bottom: 25px;box-shadow: none;border: #ebeef5 1px solid" :class="isShowApprovalProcess ? 'approvalProcessCard' : 'approvalProcessCard header-border'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="isShow">
        <span v-if="approveTypeActiveName==='DATA_RELEASE'" style="font-weight: bold;font-size: 14px;color: #636569">二代测序、扩增子测序——自动审批执行流程</span>
        <span v-else style="font-weight: bold;font-size: 14px;color: #636569">报告审批、上传说明</span>
        <i class="el-icon-arrow-up" v-show="isShowApprovalProcess" style="cursor: pointer;color: #1e6cb0"
           title="展开介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShowApprovalProcess" style="cursor: pointer;color: #1e6cb0"
           title="折叠介绍">展开</i>
      </div>

        <el-descriptions v-if="isShowApprovalProcess" :column="3" border >
          <el-descriptions-item label="服务器" style="border-top:none">
            big02
          </el-descriptions-item>
          <el-descriptions-item label="账号" style="border-top:none">
            submit
            <span v-if="approveTypeActiveName==='REPORT_UPLOAD'">（抓取）、autouser（上传）</span>
          </el-descriptions-item>
          <el-descriptions-item label="临时抓取数据路径"  style="border-top:none;">
            /mnt/new600T/submit
          </el-descriptions-item>
          <template v-if="approveTypeActiveName==='DATA_RELEASE'">
            <el-descriptions-item label="执行条件" :span="3" style="border-top:none">
              1、数据抓取成功；
              2、无项目备注或者系统自动提交
            </el-descriptions-item>
            <el-descriptions-item label="执行流程" :span="3">
              <!--         120-->
              <div style="display:flex;gap: 30px;height: 100px">
                <div class="circle">
                  <div> 1、系统自动验证样本信息及数量是否与项目管理系统一致</div>
                  <div> 2、样本数据量是否满足项目管理系统90%以上</div>
                </div>
                <div style="display: flex;flex-direction: column;justify-content: space-between;min-width: 100px;margin:6px 0px">
                  <div style="display: flex;flex-direction: column;align-items: center;">
                    <span style="color: rgb(4,136,4)">满足条件</span>
                    <i v-html="arrowheadIcon" style="color: silver"></i>
                  </div>
                  <div style="display: flex;flex-direction: column;align-items: center">
                    <span style="color: rgba(229,39,39,0.97)"> 不满足条件</span>
                    <i v-html="arrowheadIcon"></i>
                  </div>
                </div>
                <div style="display: flex;flex-direction: column;justify-content: space-between;min-width: 100px">
                  <div  style="color: rgb(4,136,4);margin-top: 25px">自动审批通过，系统自动上传</div>
                  <div  style="color: rgba(229,39,39,0.97);margin-bottom:10px">自动审批拒绝，该项目暂停，审批人员需手动处理</div>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="审批时间说明" :span="3" style="border-top:none">
              1、上午<span class='notice'>9:30</span>左右，完成<span class='notice'>昨天</span>的裸测审批；
              2、上午<span class='notice'>11:50</span>左右，完成<span class='notice'>今天上午</span>的裸测审批；
              3、下午<span class='notice'>3:30</span>左右，完成<span class='notice'>还未审批</span>的裸测审批；
              4、下午<span class='notice'>5:50</span>左右，完成<span class='notice'>今天</span>的裸测审批；
            </el-descriptions-item>
          </template>
          <template v-else>
            <el-descriptions-item label="审批项目"  style="border-top:none;">
              蛋白代谢模块中无原始数据的项目
              <span style="color: rgb(4,136,4)">（注：审批通过后将上传至<a @click="toOther"  style="color: rgb(4,136,4)">其他类型交付系统</a>）</span>
            </el-descriptions-item>
          </template>

        </el-descriptions>

    </el-card>


      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane name="pending">
          <template slot="label">
          <span>
           待处理<i v-if="tabRedDotNum('pending')" class="red-dot1">{{ tabRedDotNum('pending') }}</i>
          </span>
          </template>
        </el-tab-pane>
        <el-tab-pane label="上传中" name="consented"></el-tab-pane>
        <el-tab-pane name="failed">
          <template slot="label">
          <span>
           已失败<i v-if="tabRedDotNum('fail')" class="red-dot1">{{ tabRedDotNum('fail') }}</i>
          </span>
          </template>
        </el-tab-pane>
        <el-tab-pane label="已成功" name="success"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
      </el-tabs>
      <div style="width:100%;">
        <w-table ref="wMyTable" :columns="columns" :table-data="tableData"
                 @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
                 :table-col-check="{ isShow:true,name:`nakedApproval_${this.approveTypeActiveName}`}"
                 :page="page" @pageChange="handlePagePagination">
        <span slot="platform" slot-scope="{text,record}">
          {{ getPlatform(text) }}
        </span>
          <!--       模块-->
          <div slot="model" slot-scope="{text, record, index}">
            {{ getModelName(text) }}
          </div>
          <!--       合同数据量-->
          <div slot="contractNum" slot-scope="{text, record, index}">
            {{ text === -1 || !text ? 'NA' : text }}
          </div>
          <!--       折叠-->
          <div slot="foldInfo" slot-scope="{text, record, index}">
            <ex-fold-table-cell :scope="{text:text.split('|'), record, index}"></ex-fold-table-cell>
          </div>
          <!--        样本信息-->
          <span slot="sampleInfo" slot-scope="{text,record}">
          <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record)">查看样本<i class="viewIcon" v-html="viewDetailIcon"></i></span>
        </span>
          <!--        路径-->
          <div slot="dataPath" slot-scope="{text,record}">
            <div v-if="text">
              <el-tooltip content="查看详情">
                <a-icon type="file-search" style="color: #177bd3;font-size: 17px" @click="lookDataPath(record)"/>
              </el-tooltip>
              <span>{{ text.substring(0, 20) }}...</span>
            </div>
            <div v-else>
            </div>
          </div>
          <!--        备注-->
          <span slot="remark" slot-scope="{text,record,column}">
          <div v-if="text">
            <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
          </div>
          <div v-else>
          </div>
      </span>
          <!--        审批备注-->
          <span slot="approveRemark" slot-scope="{text,record,column}">

          <div v-if="text">
             <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
          </div>
          <div v-else>
          </div>
        </span>
          <!--        审批状态-->
          <span slot="approvalStatus" slot-scope="{text,record}">
          <el-tag :type="approvalStatusColor(record)">  {{
              getApprovalStatus(record)
            }}</el-tag>
        </span>
          <!--        是否暂停-->
          <span slot="isStop" slot-scope="{text,record}">
          <el-tag v-if="text" type="danger">是</el-tag>
           <el-tag v-else type="success">否</el-tag>
        </span>
          <span slot="salesName" slot-scope="{text,record}">
            {{ text ? text.map(item => item.name).join(';') : '' }}
        </span>
          <span slot="customerName" slot-scope="{text,record}">
            {{ text ? Array.from(new Set(text.map(item => item.realName))).join(';') : '' }}
        </span>
          <span slot="approveMsg" slot-scope="{text, record}">
              <div class="descriptionTxt">{{ text }}</div>
          </span>
          <template v-for="projectSystemInfoSlot in projectSystemInfoSlotList" :slot="projectSystemInfoSlot"  slot-scope="{text, record}">
            <approval-table-slot :slot-type="projectSystemInfoSlot" :record="record" ></approval-table-slot>
          </template>
          <div slot="operation" slot-scope="{text,record}">
            <el-button size="mini" type="primary" v-if="record.auditStatus==='PENDING'"
                       @click="handleConfirmDataPath(record)">确认上传
            </el-button>
            <el-button size="mini" type="warning" @click="handleStop(record)"
                       v-if="record.auditStatus==='PENDING'&&!record.isStop">暂停
            </el-button>
            <el-button size="mini" type="info" v-if="record.remark&&record.isStop" @click="lookApproveRemark(record)">
              查看暂停原因
            </el-button>
            <el-button size="mini" type="info" v-if="record.logInfo" @click="handleFailLog(record)">查看失败日志
            </el-button>
          </div>
          <div slot="filterDropdownModel"
               slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
               style="padding: 8px;width:290px">
            <div style="padding: 0px 10px;">
              <el-radio-group v-model="selectedKeys[0]">
                <el-row :gutter="30">
                  <el-col :span="12">
                    <el-radio label="二代测序">二代测序</el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio label="扩增子测序">扩增子测序</el-radio>
                  </el-col>
                </el-row>
                <el-row :gutter="30">
                  <el-col :span="12">
                    <el-radio label="三代测序">三代测序</el-radio>
                  </el-col>
                  <el-col :span="12">
                    <el-radio label="蛋白代谢组测序">蛋白代谢组测序</el-radio>
                  </el-col>
                </el-row>
                <el-row :gutter="30">
                  <el-col :span="12">
                    <el-radio label="纯分析">纯分析</el-radio>
                  </el-col>
                </el-row>
              </el-radio-group>
            </div>
            <div style="text-align: center;margin-top:5px">
              <a-button type="primary" icon="search"
                        size="small"
                        style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
                搜索
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
              </a-button>
            </div>
          </div>
        </w-table>
      </div>

    <picture-loading v-if="loading"></picture-loading>
    <!--    报告路径弹框-->
    <data-path-dialog v-if="showDataPathDialog" :show-dialog.sync="showDataPathDialog" :select-detail="selectDetail"
                      @submit="submitDataPath">
    </data-path-dialog>
    <!--    失败日志信息-->
    <log-detail v-if="showFailLogDialog" :showDialog.sync="showFailLogDialog"
                :log-content="selectDetail"></log-detail>
    <!--    查看备注-->
    <look-detail v-if="showRemarkDetailDialog" :show-dialog.sync="showRemarkDetailDialog" :select-detail="selectDetail">
      <template slot="content" slot-scope="content">
        <el-form-item label="查看原因">
          <el-input v-model="content.note" type="textarea" readonly :autosize="{ minRows: 3,}"></el-input>
        </el-form-item>
      </template>
    </look-detail>
    <!--    查看审批备注-->
    <look-detail v-if="showApproveRemarkDetailDialog" :show-dialog.sync="showApproveRemarkDetailDialog"
                 :select-detail="selectDetail">
      <template slot="content" slot-scope="content">
        <el-form-item label="查看备注">
          <el-input v-model="content.remark" type="textarea" readonly
                    :autosize="{ minRows: 2, maxRows: 12 }"></el-input>
        </el-form-item>
      </template>
    </look-detail>
    <!--   确认路径弹框-->
    <approve-dialog v-if="showConfirmDataPathDialog" :show-approve-dialog="showConfirmDataPathDialog"
                    :select-detail="selectDetail"
                    title="确认路径"
                    @submit="submitConfirmDataPath">
      <template slot="resultInfo" slot-scope="{approveForm}">
        <el-form :model="approveForm" label-width="100px">
          <el-form-item label="原始数据路径">
            <el-input type="textarea" :value="approveForm.dataPath" :autosize="{ minRows: 2, maxRows: 12 }" readonly>
            </el-input>
          </el-form-item>
          <el-form-item label="操作" :required="true">
            <el-radio-group v-model="approveForm.result">
              <el-radio label="pass">确认上传</el-radio>
              <el-radio label="amendment">修改路径并上传</el-radio>
              <el-radio label="refuse">取消上传</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="修改后路径" v-if="approveForm.result==='amendment'" prop="newDataPath"
                        :rules="[{required:true,message:'请输入修改后的原始数据路径',trigger:'blur'}]">
            <el-input type="textarea" v-model="approveForm.newDataPath" :autosize="{ minRows: 2, }">
            </el-input>
          </el-form-item>
          <el-form-item label="操作理由">
            <el-input v-model="approveForm.msg" autocomplete="off" type="textarea" :rows="3"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </approve-dialog>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
  </div>
</template>

<script>
import {tableOperationMixin} from "@/mixins/tableOperation";
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import PictureLoading from "@/components/customerTable/PictureLoading";
import {
  approvalStatusColor,
  getApprovalStatusChByEn,
  getPlatformChByEn,
  getPlatformEnByCh,
  modelChEn
} from "@/utils/ch_en_trans";
import ApproveDialog from "@/components/approve/ApproveDialog";
import ApproveDetailDialog from "@/components/approve/ApproveDetailDialog";
import ExFoldTableCell from "@/components/ExFoldTableCell";
import FileHostPathDialog from "@/components/FileHostPathDialog";
import {
  nakedApproval,
  nakedApprovalList,
  nakedApprovalModify,
  nakedDataPathApproval, nakedStopEmail
} from "@/api/naked/rawData/approval";
import {nakedApprovalTableCol} from "@/utils/data/tableCol/nakedApprovalTableCol";
import LogDetail from "@/components/approve/LogDetail";
import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";
import DataPathDialog from "@/components/approve/DataPathDialog";
import {needRedDoltInfo} from "@/utils/data/basicData/leftNavData";
import LookDetail from "@/components/approve/LookDetail";
import {modelNameEnCh} from "@/utils/data/basicData/modelNameEnCh";
import {arrowheadIcon, viewDetailIcon} from "@/utils/iconUtils";
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";
import ApprovalTableSlot from "@/components/approve/ApprovalTableSlot.vue";
import {projectSystemInfoSlotList} from "@/utils/enums/enumn";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  name: "NakedApproval",
  components: {
    ApprovalTableSlot,
    SampleInfoDialog,
    LookDetail,
    DataPathDialog,
    LogDetail,
    ApproveDetailDialog,
    ApproveDialog,
    PictureLoading,
    ExFoldTableCell,
    FileHostPathDialog
  },
  mixins: [tableOperationMixin],
  data() {
    return {
      locale: zhCN,
      loading: true, //是显示加载
      title: '添加客户',
      searchConditionTag: [],
      sortConditionTag: [],
      tableData: [],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      approveTypeActiveName:'DATA_RELEASE',
      activeName: 'pending',
      showApproveDialog: false,//审批弹框
      showFailLogDialog: false,//失败日志弹框
      showDataPathDialog: false,//路径弹框
      showRemarkDetailDialog: false,//备注弹框
      showApproveRemarkDetailDialog: false,//审批备注弹框
      showConfirmDataPathDialog: false,//确认路径弹框
      selectDetail: '',
      arrowheadIcon:arrowheadIcon,
      isShowApprovalProcess:true,
      sampleInfoDialog:false,
      viewDetailIcon: viewDetailIcon,
      projectSystemInfoSlotList:projectSystemInfoSlotList
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    columns: {
      get() {
        let operation = {
          title: '操作',
          key: 'operation',
          scopedSlots: {customRender: 'operation'},
          width: 300,
        }
        let reviewer = [{
          title: '审批人',
          dataIndex: 'auditName',
          key: 'auditName',
        },
          {
            title: '审批时间',
            dataIndex: 'operateTime',
            key: 'operateTime',
          }, {
            title: '审批备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
              customRender: 'approveRemark'
            }
          },]
        let columns = nakedApprovalTableCol(this.searchConditionTag || {}).filter(i=>!i.model||i.model.includes(this.approveTypeActiveName))
        if (this.activeName !== 'pending') {
          columns.splice(columns.length, 0, ...reviewer)
          if (!['consented', 'success'].includes(this.activeName)) {
            columns.splice(columns.length, 0, operation)
          }
        } else {
          columns.splice(columns.length, 0, operation)
        }
        return columns
      }
    },
  },
  methods: {
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    //获取数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
        order: ['success', 'pending'].includes(this.activeName) ? 'createTime.desc' : 'createTime.asc'
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      let sendData = {
        'query#approvalType.EQ':this.approveTypeActiveName
      }
      sendData.auditStatus = [this.activeName.toLocaleUpperCase()]
      sendData = this.getSearch(sendData)
      nakedApprovalList(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        if (item.key === 'platform') {
          if (item.value !== '交付系统') {
            sendData[item.key] = getPlatformEnByCh(item.value)
          }
        } else if (item.key === 'projectModel') {
          sendData[item.key] = modelChEn[item.value]
        } else {
          sendData[item.key] = item.value
        }
      })
      return sendData
    },
    //表格的选择框
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item => item.id)
    },
    //页码的变动
    handlePagePagination(page) {
      this.loading = true
      this.page.currentNum = page.currentNum
      if (page.pageSize) {
        this.page.pageSize = page.pageSize
      } else {
        this.page.pageSize = this.page.total
      }
      this.getData()
    },
    getModelName(model) {
      return modelNameEnCh[model]
    },
    getPlatform(text) {
      return getPlatformChByEn(text)
    },
    getApprovalStatus(record) {
      let status = getApprovalStatusChByEn(record.auditStatus)
      if (status === '待审批') {
        if (record.isStop) {
          return '已暂停'
        } else {
          return '待审批'
        }
      }
      return getApprovalStatusChByEn(record.auditStatus)
    },
    approvalStatusColor(record) {
      let type = approvalStatusColor[record.auditStatus]
      if (type === 'primary') {
        if (record.isStop) {
          return 'danger'
        }
      }
      return type
    },
    handleClickTab(tab) {
      this.getData('change')
    },
    handleApproveTypeClickTab(tab) {
      this.activeName='pending'
      this.getData('change')
    },
    // 审批
    handleApprove(val) {
      this.selectDetail = val
      this.selectDetail.modifyPath = true
      this.showApproveDialog = true
    },
    //提交审批
    submitApprove(data, type) {
      this.showApproveDialog = false
      if (type !== 'cancel') {
        nakedApproval(data).then(res => {
          if (res.code === 200) {
            this.$store.dispatch(`dataStatus/getRedDoltNum`, needRedDoltInfo[0])
            this.getData('search')
            this.$messageUi.success('审批成功')
          }
        })
      }
    },
    handleStop(record) {
      this.$prompt('暂停该项目后会停止发送邮件，您确定要暂停？', '提示', {
        type: 'warning',
        confirmButtonText: '确定暂停',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPlaceholder: '请输入原因（非必填）',
      }).then(({value}) => {
        nakedStopEmail(record.id, value).then(res => {
          if (res.code === 200) {
            this.$messageUi.success('暂停成功')
            this.getData()
          }
        })
      }).catch(() => {

      })
    },
    // 确认路径
    handleConfirmDataPath(record) {
      this.selectDetail = record
      this.showConfirmDataPathDialog = true
    },
    // 提交确认路径
    submitConfirmDataPath(data, type) {
      let sendData = null
      let operation = ''

      if (type !== 'cancel') {
        if (data.result === 'refuse') {
          operation = 'refuse'
          sendData = data.msg
        } else {
          operation = 'pass'
          if (data.result === 'amendment') {
            if (!data.newDataPath) {
              this.$messageUi.error('请输入修改后的原始数据路径')
              return
            }
            sendData = {
              path: data.newDataPath,
              approvalRemark: data.msg
            }
          } else {
            if (!data.dataPath) {
              this.$messageUi.error('原始数据为空，请选择修改路径')
              return;
            }
            sendData = {
              path: data.dataPath,
              approvalRemark: data.msg
            }
          }
        }
        nakedDataPathApproval(data.id, operation, sendData).then(res => {
          this.showConfirmDataPathDialog = false
          if (res.code === 200) {
            this.$store.dispatch(`dataStatus/getRedDoltNum`, needRedDoltInfo[0])
            this.$store.dispatch(`dataStatus/getRedDoltNum`, needRedDoltInfo[2])
            this.getData('search')
            this.$messageUi.success('提交成功')
          }
        })

      } else {
        this.showConfirmDataPathDialog = false
      }
    },
    handleModify(record) {
      this.selectDetail = record
      this.showDataPathDialog = true
    },
    // 查看路径
    lookDataPath(record) {
      this.selectDetail = record
      this.showDataPathDialog = true
    },
    // 查看备注
    lookRemark(record) {
      this.selectDetail = record
      this.showRemarkDetailDialog = true
    },
    // 查看备注
    lookApproveRemark(record) {
      this.selectDetail = record
      this.showApproveRemarkDetailDialog = true
    },
    //修改路径
    submitDataPath(data) {
      nakedApprovalModify(data.id, data.dataPath).then(res => {
        if (res.code === 200) {
          this.showDataPathDialog = false
          this.$store.dispatch(`dataStatus/getRedDoltNum`, needRedDoltInfo[1])
          this.$store.dispatch(`dataStatus/getRedDoltNum`, needRedDoltInfo[3])
          this.getData()
          this.$messageUi.success('修改成功')
        }
      }).catch(() => {
        this.showDataPathDialog = false
      })
    },
    lookSampleInfo(row) {
      this.selectDetail = {
        projectId:row.projectInfo.id,
        platform:'LUOCE',
        isNeedFilterSample:row.hasSampleNames,
        sampleNameList:row.sampleNames?row.sampleNames:[]
      }
      this.sampleInfoDialog = true
    },
    //查看失败日志
    handleFailLog(record) {
      this.selectDetail = record.logInfo.split('\n')
      this.showFailLogDialog = true
    },
    tabRedDotNum(key,type=this.approveTypeActiveName) {
      return this.$store.getters[`dataStatus/${type==='REPORT_UPLOAD'?'getNakedReportRedDoltNum':'getNakedDataReleaseRedDoltNum'}`][key]
    },
    isShow(){
      this.isShowApprovalProcess=!this.isShowApprovalProcess
    },
    toOther(){
      this.$router.push('/projectRawData')
    }
  }
}
</script>

<style scoped>
.descriptionTxt {
  width: 200px;
  word-wrap: break-word;
  /*padding: 2px !important;*/
  white-space: pre-wrap;
}

.red-dot1 {
  font-family: Consolas, Courier New, monospace;
  top: 3px;
  right: 8px;
}
.red-dot2 {
  font-family: Consolas, Courier New, monospace;
  top: -10px;
  right: -12px;
}

.circle {
  /*width: 300px;*/
  width: 400px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 25px;
  background-color: #eef5fe;
  padding: 0 15px;
  gap: 8px;
}
/deep/ .is-bordered-label  {
  /*width: 80px;*/
  min-width: 80px;
}
/deep/  .approvalProcessCard .el-card__header {
  padding: 10px 15px !important;
  background: #fbfdfd;
}
/deep/ .header-border .el-card__body {
  padding: 0px;


}
.notice {
  color: rgb(231, 64, 64)
}
/deep/ .el-descriptions-item__cell{
  min-width: 120px;
}
</style>
